module.exports = __webpack_public_path__ + "static/media/rezi.61c0fb7a.gif";